import TutorialCard from '../../components/TutorialCard';
export default function WatchTutorial() {
  const videos = [
    {
      id: 1,
      src: "https://www.youtube.com/embed/BXTr9u2sc-Q?t=37s",
      watchUrl: "https://www.youtube.com/watch?v=BXTr9u2sc-Q&t=37s",
      title: "E-Commerce GST-all doubts cleared"
    },
    {
      id: 2,
      src: "https://www.youtube.com/embed/rTETGq3TeIw",
      watchUrl: "https://www.youtube.com/watch?v=rTETGq3TeIw",
      title: "Start Your e-commerce with low Investment"
    },
    {
      id: 3,
      src: "https://www.youtube.com/embed/7gq4Jf9Bd_Q",
      watchUrl: "https://www.youtube.com/watch?v=7gq4Jf9Bd_Q",
      title: "Selling on Meesho with EnrollmentID-no GST"
    },
    {
      id: 4,
      src: "https://www.youtube.com/embed/nkdxn0VZnYM?t=8s",
      watchUrl: "https://www.youtube.com/watch?v=nkdxn0VZnYM&t=8s",
      title: "Can We Make Money in e-commerce in 2026?"
    },
    {
      id: 5,
      src: "https://www.youtube.com/embed/sjoplBFOxLM?t=7s",
      watchUrl: "https://www.youtube.com/watch?v=sjoplBFOxLM&t=7s",
      title: "Avoid this Product for e-commerce Business"
    },
    {
      id: 6,
      src: "https://www.youtube.com/embed/7gq4Jf9Bd_Q",
      watchUrl: "https://www.youtube.com/@ecom_tamil/playlists",
      title: "How Many Months do We Pay GST for e-commerce"
    },
    {
      id: 7,
      src: "https://www.youtube.com/embed/7gq4Jf9Bd_Q",
      watchUrl: "https://www.youtube.com/watch?v=7gq4Jf9Bd_Q",
      title: "Selling on Meesho with EnrollmentID-no GST"
    },
    {
      id: 8,
      src: "https://www.youtube.com/embed/rTETGq3TeIw",
      watchUrl: "https://www.youtube.com/watch?v=rTETGq3TeIw",
      title: "Start Your e-commerce with low Investment"
    }
  ];

  return (
    <section id="tutorials" className="py-16 bg-gradient-to-br from-white via-amber-50/20 to-white relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-16 animate-fade-in-up">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-orange-50 border border-orange-100 text-xs font-bold text-orange-600 tracking-wider uppercase mb-4">
            <svg className="w-4 h-4 text-orange-500" fill="currentColor" viewBox="0 0 24 24">
              <path d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z" />
            </svg>
            Free Learning
          </div>
          <h2 className="text-3xl md:text-5xl font-extrabold text-gray-900 mb-6 tracking-tight">
            Watch <span className="text-orange-500">Tutorials</span>
          </h2>
          <p className="max-w-2xl mx-auto text-gray-600 text-base md:text-lg leading-relaxed">
            Explore our collection of step-by-step masterclasses.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 -mx-4 px-4 sm:mx-0 sm:px-0">
          {videos.map((video) => (
            <TutorialCard
              key={video.id}
              id={video.id}
              title={video.title}
              watchUrl={video.watchUrl}
              src={video.src}
            />
          ))}
        </div>


      </div>
    </section>
  );
};
